import axios from "axios";
//import ApiService from "../../api/apiservice";

const state = {
  localConfig: {}
};

const getters = {};

const actions = {
  async getLocalConfig() {
    //debugger
    console.log('getLocalConfig');
    /*var baseURL = localStorage.getItem("baseURL");
    if (baseURL) {
      axios.defaults.baseURL = baseURL;
      ApiService.init()
    } else {
      console.log(window.location.href);
      if (window.location.href != window.location.origin+'/') {
        window.location.href = '/'
      }
    }*/

    await fetch("../config.json")
      .then((r) => r.json())
      .then((response) => {
        console.log(response);

        var promises = []
       
        if (response.localBaseURL) {
         try{
          promises.push(axios.get(response.localBaseURL + "test"))
         }catch{
          console.log("error")
         }
         
        }
        if (response.globalBaseURL) {
        
         //debugger
          promises.push(axios.get(response.globalBaseURL + "test"))
        }
        return Promise.any(promises).then(result => {
          //debugger
          console.log(result)
          var lastIndex = result.config.url.lastIndexOf("/")
          var baseURL = result.config.url.substr(0, lastIndex) + "/"
          console.log(baseURL);
          axios.defaults.baseURL = baseURL;
          //ApiService.init()
          console.log("axios.defaults.baseURL:")
          console.log(axios.defaults.baseURL)
        }).catch(e => {
          //debugger
          console.log(e);
        })
      


      });
//debugger
  },
};

const mutations = {
};

export default {
  state,
  getters,
  actions,
  mutations
}